import { AxisRenderer, ValueAxis } from '@amcharts/amcharts5/xy';

const calculateMax = (data: any[]) => data.reduce((max, item) => Math.max(max, item.value), 0);

export const setAxisMaxValue = (data: any[], axis: ValueAxis<AxisRenderer>) => {
  const maxDataValue = calculateMax(data);
  const max = axis.get('max');
  if (max) {
    maxDataValue > max && axis.set('max', maxDataValue);
  }
};
